import React from 'react'
import { View } from 'react-native'
import { styles } from './styles'

export const ChatView = () => {
  return <View style={styles.chatBlurUnderlay} />
}
